import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const RegistroCliente = () => {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [cedula, setCedula] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [telefono, setTelefono] = useState("");
  const [nacionalidad, setNacionalidad] = useState("Uruguay");
  const [descripcion, setDescripcion] = useState("");

  // Función para limpiar campos peligrosos (si es necesario)
  const sanitizeInput = (input) => {
    const tempElement = document.createElement("div");
    tempElement.textContent = input;
    return tempElement.innerHTML;
  };

  const validarCampos = () => {
    if (apellido && apellido.length > 20) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El apellido no puede tener más de 20 caracteres.",
      });
      return false;
    }

    if (cedula && cedula.length > 20) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "La cédula no puede tener más de 20 caracteres.",
      });
      return false;
    }

    if (telefono && telefono.length > 20) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El teléfono no puede tener más de 20 caracteres.",
      });
      return false;
    }

    if (nacionalidad && nacionalidad.length > 20) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "La nacionalidad no puede tener más de 20 caracteres.",
      });
      return false;
    }

    // Validación del formato de la fecha de nacimiento (YYYY-MM-DD) - solo si se proporciona
    if (fechaNacimiento) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(fechaNacimiento)) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "La fecha de nacimiento debe tener el formato YYYY-MM-DD y el año debe tener cuatro dígitos.",
        });
        return false;
      }

      // Validación para que el año no tenga más de 4 dígitos
      const year = fechaNacimiento.split("-")[0];
      if (year.length !== 4) {
        Swal.fire({
          icon: "error",
          title: "Año no válido",
          text: "El año debe tener exactamente 4 dígitos.",
        });
        return false;
      }

      // Validación para que la fecha de nacimiento no sea futura
      const fechaNacimientoDate = new Date(fechaNacimiento);
      const fechaActual = new Date();
      if (fechaNacimientoDate > fechaActual) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "La fecha de nacimiento no puede ser posterior a la fecha actual.",
        });
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarCampos()) {
      return;
    }

    // Verificar los datos antes de enviarlos
    console.log("Datos enviados al backend (raw):", {
      nombre,
      ...(apellido && { apellido }),
      ...(cedula && { cedula }),
      ...(fechaNacimiento && { fecha_nacimiento: fechaNacimiento }),
      ...(telefono && { telefono }),
      ...(nacionalidad && { nacionalidad }),
      ...(descripcion && { descripcion }),
    });

    // Adaptar el formato de los datos al backend si es necesario
    const datosFormateados = {
      nombre,
      ...(apellido && { apellido }),
      ...(cedula && { cedula }),
      ...(fechaNacimiento && { fecha_nacimiento: fechaNacimiento }),
      ...(telefono && { telefono }),
      ...(nacionalidad && { nacionalidad }),
      ...(descripcion && { descripcion }),
    };

    console.log("Datos formateados para el backend:", datosFormateados);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clientes`,
        datosFormateados,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Respuesta del backend:", response.data);
      Swal.fire(
        "Cliente registrado",
        "El cliente se ha registrado correctamente",
        "success"
      );
    } catch (error) {
      if (error.response && error.response.status === 409) {
        // Manejo específico del error 409 (cédula ya registrada)
        Swal.fire({
          icon: "error",
          title: "Error de registro",
          text: "Ya existe un cliente registrado con esta cédula.",
        });
      } else {
        // Manejo de otros errores
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo registrar el cliente. Intente nuevamente.",
        });
      }

      console.error("Error al registrar cliente:", error);
    }
  };

  // Función para limpiar el formulario
  const limpiarFormulario = () => {
    setNombre("");
    setApellido("");
    setCedula("");
    setFechaNacimiento("");
    setTelefono("");
    setNacionalidad("Uruguay");
    setDescripcion("");
  };

  return (
    <section className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-100">
      <div className="p-6 bg-white shadow-lg rounded-lg w-full max-w-2xl">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-800">
            Registrar Cliente
          </h2>
          <p className="text-gray-500">
            Complete el formulario para registrar un nuevo cliente.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <Input
            label="Nombre"
            value={nombre}
            onChange={(value) => setNombre(value)}
            required
          />
          <Input
            label="Apellido"
            value={apellido}
            onChange={setApellido}
          />
          <Input label="Cédula" value={cedula} onChange={setCedula} />
          <Input
            label="Fecha de Nacimiento"
            value={fechaNacimiento}
            onChange={(value) => setFechaNacimiento(value)}
            type="date"
          />
          <Input
            label="Teléfono"
            value={telefono}
            onChange={setTelefono}
          />
          <Input
            label="Nacionalidad"
            value={nacionalidad}
            onChange={setNacionalidad}
          />
          <Textarea
            label="Descripción (opcional)"
            value={descripcion}
            onChange={(value) => setDescripcion(value)}
          />
          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={limpiarFormulario}
              className="border p-3 bg-red-600 text-white hover:bg-red-700 transition rounded mr-2"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="border p-3 bg-green-600 text-white hover:bg-green-700 transition rounded ml-2"
            >
              Registrar
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

const Input = ({ label, value, onChange, type = "text", required = false }) => (
  <div className="flex flex-col">
    <label className="mb-2 text-gray-600">{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      className="border p-2 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

const Textarea = ({ label, value, onChange }) => (
  <div className="flex flex-col">
    <label className="mb-2 text-gray-600">{label}</label>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="border p-2 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

export default RegistroCliente;
